export default __webpack_public_path__ + "static/media/heart-filled.3b141e14.svg";